import React, { useEffect, useState } from 'react';
import { FormElement, FormLabel, FormInput, FormNumberInput, DragHandle } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';


export const WebFetchNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard
      title="Web Fetch"
      description="Fetch an allowlisted web page and extract readable content"
      onAdd={() => onAdd(500)}
      style={style}
    />
  )
};

export const WebFetchNode = ({ id, data }) => {
  const [localData, setLocalData] = useState({
    url: "{input}",
    urlMode: "auto",
    extract: "text",
    timeoutMs: 15000,
    maxBytes: 2000000,
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    setLocalData({
      url: data.url || "{input}",
      urlMode: data.urlMode || "auto",
      extract: data.extract || "text",
      timeoutMs: data.timeoutMs || 15000,
      maxBytes: data.maxBytes || 2000000,
    });
  }, [data]);

  const update = (patch) => {
    setLocalData((current) => ({ ...current, ...patch }));
    data.onUpdateData(id, patch);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => data.onDelete(id)} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="Web Fetch" />

        <FormElement>
          <FormLabel label="URL" />
          <FormInput
            placeholder="https://example.com/page or {input}"
            value={localData.url}
            onChange={(e) => update({ url: e.target.value })}
          />
        </FormElement>

        <FormElement>
          <FormLabel label="URL Source" />
          <select
            value={localData.urlMode}
            onChange={(e) => update({ urlMode: e.target.value })}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid var(--main-border-color)",
              backgroundColor: "var(--content-item-bg)",
              color: "var(--main-font-color)",
            }}
          >
            <option value="auto">Auto — literal is trusted, placeholders require allowlist</option>
            <option value="dynamic">Dynamic — always require allowlist</option>
            <option value="literal">Literal — trusted URL, bypass allowlist</option>
          </select>
        </FormElement>

        <FormElement>
          <FormLabel label="Extract" />
          <select
            value={localData.extract}
            onChange={(e) => update({ extract: e.target.value })}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid var(--main-border-color)",
              backgroundColor: "var(--content-item-bg)",
              color: "var(--main-font-color)",
            }}
          >
            <option value="text">Readable text</option>
            <option value="html">Text + HTML</option>
            <option value="links">Text + links</option>
            <option value="json">JSON</option>
            <option value="all">All</option>
          </select>
        </FormElement>

        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <FormElement style={{ width: "50%" }}>
            <FormLabel label="Timeout (ms)" />
            <FormNumberInput
              value={localData.timeoutMs}
              onChange={(e) => update({ timeoutMs: Number(e.target.value) })}
              min={1000}
              max={60000}
              step={1000}
            />
          </FormElement>
          <FormElement style={{ width: "50%" }}>
            <FormLabel label="Max bytes" />
            <FormNumberInput
              value={localData.maxBytes}
              onChange={(e) => update({ maxBytes: Number(e.target.value) })}
              min={1024}
              max={5000000}
              step={1024}
            />
          </FormElement>
        </div>

        <div style={{ fontSize: "12px", opacity: 0.75, lineHeight: 1.4 }}>
          Literal URLs are trusted by default. URLs built from {"{input}"} or
          context placeholders must pass the server-side web allowlist.
          Private/internal addresses and non-default ports are always blocked.
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        style={{ top: "110px", height: "12px", width: "12px" }}
        id="web-fetch-input"
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ height: "12px", width: "12px" }}
        id="web-fetch-output"
      />
    </div>
  );
};

export default WebFetchNode;
